import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';
import { HeaderService } from './header.service';
import { lastValueFrom } from 'rxjs';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UserManagementService } from 'src/app/modules/auth/administration/user-management/user-management.service';
import { UserDomainType, UserStatus } from 'src/app/common/enum/user-domain';
import { CommonNotificationService } from 'src/app/common/service/common-notification.service';
import { MartkUserNotificationMsg } from 'src/app/common/enum/notification-options.enum';
import { RoleType } from 'src/app/common/enum/role-type.enum';
import { AuthSessionService } from 'src/app/providers/auth-session/auth-session.service';
declare var $: any;
import moment from 'moment';
import * as _ from 'lodash';
import { DepartmentId } from 'src/app/common/enum/department';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {

  //📌 Notification Objects
  public markNotification = MartkUserNotificationMsg;
  notifications: any[] = [];
  notificationsList: any[] = [];
  notificationUnreadCount: number = 0;
  notificationCount: number = 0;

  navigateURL: string = "";
  showNotificationPanel: boolean = false;
  @ViewChild('notificationWrapper') notificationWrapper: ElementRef;

  userStatus = UserStatus;
  userName: string = "";
  userAliasName: string = "";
  facilityName: string = "";


  location: Location;
  headerPageTitle: string | null = "";


  showLogoutConfirmationPopup: boolean = false;
  public events: string[] = [];
  showSaveConfirmation: boolean = false;
  currentUserDomain: number = 0;
  facilityDomainId: any = UserDomainType.External;
  userDepartmentId: any;
  applicationAccessDenied: boolean = false;

  isSpecialist: boolean = false;
  isQualityAnalyst: boolean = false;
  isLeadOrManager: boolean = false;
  updatedDate: string = "";

  constructor(
    private _authSession: AuthSessionService,
    public _coreHelper: CoreHelperService,
    private router: Router,
    location: Location,
    public _headerService: HeaderService,
    public _userService: UserManagementService,
    private _commonNotificationService: CommonNotificationService,
  ) {
    this.applicationAccessDenied = this._coreHelper.applicationPermissionDenied();
    this.setLoggedInUserRole();
    this.currentUserDomain = this._coreHelper.getUserDomain();
    this.location = location;
    this._coreHelper.selectedUserStatus = this._coreHelper.getUserStatusId();
  }

  getReportUpdatedDate() {
    if (this.router.url.includes('report')) {
      const now = new Date();
      let result = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        6,
        30,
        0,
        0
      );
      if (now < result) {
        result.setDate(result.getDate() - 1);
      }
      this.updatedDate = result.toLocaleDateString();
    } else {
      this.updatedDate = null;
    }
  }

  async ngOnInit() {
    await this.loadLoggedInUserInformation();

    //Below is alternative of Push Notification.
    setInterval(() => this.getNotificationByUser(), 60000);
  }

  ngAfterViewInit() {
    this._coreHelper.headerTitle.subscribe((data) => {
      this.headerPageTitle = data;
    });
  }

  commingSoon() {
    this._commonNotificationService.displaySuccessMessage("Coming soon....!");
  }

  setLoggedInUserRole() {
    let currentUserRole = this._coreHelper.getRoleTypeId();
    this.isSpecialist = (currentUserRole == RoleType.Specialist)
    this.isQualityAnalyst = (currentUserRole == RoleType.QA)
    this.isLeadOrManager = (currentUserRole == RoleType.Lead)

    this.userDepartmentId = this._coreHelper.getOpsDepartmentId();
  }

  async loadLoggedInUserInformation() {
    this.userName = this._coreHelper.getUserFullName();
    this.facilityName = this._coreHelper.getFacilityName();
    let userAlias = this._coreHelper.getUserAlias();
    this.userAliasName = (userAlias != undefined && userAlias != null && userAlias.length > 0) ? this.userAliasName = userAlias : "";
  }

  isFacilityUser() {
    return (this.currentUserDomain === UserDomainType.External);
  }

  isVOBDepartment() {
    return (this.userDepartmentId === DepartmentId.Vob);
  }

  private log(event: string, arg?: any): void {
    this.events.unshift(`${event} ${arg || ""}`);
  }

  setPageTitle(title: string) {
    localStorage.setItem('title', title)
  }

  getPageTitle() {
    this.getReportUpdatedDate();

    var urlString = this.location.prepareExternalUrl(this.location.path());
    if (urlString.charAt(0) === '#') {
      urlString = urlString.slice(1);
    }
    if (urlString.charAt(0) === '?') {
      urlString = urlString.slice(1);
    }
    let currentPageTitle = this._headerService.getPageTitleFromUrl(urlString, this.isSpecialist, this.isQualityAnalyst);
    if (currentPageTitle != null && currentPageTitle != undefined && currentPageTitle.length > 0) {
      return currentPageTitle;
    }
    return 'Dashboard';
  }


  //#region Logout User Changes
  async logout() {
    this.showLogoutConfirmationPopup = true;
  }

  async updateUserStatus(userStatus: number) {
    let requestModel = {
      userId: this._coreHelper.getUserId(),
      isLogin: userStatus === UserStatus.Offline ? 0 : 1,
      spMode: 1,
      userStatusId: userStatus
    }
    if (requestModel.userId != undefined || requestModel.userId != null) {
      await lastValueFrom(this._userService.addUpdateSignedUser(requestModel)).then((response) => {
        this._coreHelper.setUserStatusId(response?.apiData);
      }).catch(() => null);
      // Offline is only set by logoutUser(), which ends the session afterwards. Don't navigate
      // to the login page here: it would restore the still-valid cookie session first.
    };
  }

  async logoutUser(popup?: boolean) {
    this.showLogoutConfirmationPopup = false;
    await this.updateUserStatus(UserStatus.Offline);
    this._commonNotificationService.displayInfoMessage("Logging out, Please wait..");
    // Ends the cookie session on the API (and Entra, for SSO users) and clears the local cache.
    await this._authSession.logout();
    this._commonNotificationService.displaySuccessMessage("You have been successfully logged out.");
  }

  onLogoutClose() {
    this.showLogoutConfirmationPopup = false;
  }
  //#endregion



  //👤 #region Profile Panel
  showProfilePanel: boolean = false;
  @ViewChild('profileWrapper') profileWrapper: ElementRef;
  userEmail: string = '';
  userRoleName: string = '';
  facilitiesLabel: string = '—';
  lastSignIn: string = '—';

  // "Viewing as" is a prototype-only switcher. TODO: hide in production (e.g. environment flag / admin role).
  showViewingAs: boolean = true;
  viewAsRoles: { id: number, name: string }[] = [];
  viewAsUsers: { id: any, name: string }[] = [];
  viewAsRoleId: number = null;
  viewAsUserId: any = null;

  get userInitials(): string {
    const parts = (this.userName || '').trim().split(/\s+/).filter(p => p.length > 0);
    if (parts.length === 0) return '?';
    return ((parts[0][0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
  }

  toggleProfilePanel() {
    this.showProfilePanel = !this.showProfilePanel;
    if (this.showProfilePanel) {
      this.closeNotificationPanel();
      this.loadProfilePanelInfo();
    }
  }

  closeProfilePanel() {
    this.showProfilePanel = false;
  }

  // Calls a CoreHelper getter only if it exists, so the panel works before every getter is implemented.
  private readCoreHelper(fnName: string): any {
    const fn = (this._coreHelper as any)[fnName];
    return (typeof fn === 'function') ? fn.call(this._coreHelper) : null;
  }

  loadProfilePanelInfo() {
    const roleId = this._coreHelper.getRoleTypeId();
    this.userRoleName = this.formatEnumName((RoleType as any)[roleId]) || '—';

    // TODO: confirm getter names on CoreHelperService
    this.userEmail = this.readCoreHelper('getUserEmail') || '';

    const facilities = this.readCoreHelper('getUserFacilities');
    if (Array.isArray(facilities)) {
      this.facilitiesLabel = facilities.length + (facilities.length === 1 ? ' facility' : ' facilities');
    } else if (this.isFacilityUser() && this.facilityName) {
      this.facilitiesLabel = this.facilityName;
    } else {
      this.facilitiesLabel = '—';
    }

    const lastLogin = this.readCoreHelper('getLastLoginDate');
    this.lastSignIn = lastLogin ? moment.utc(lastLogin).local().format('MM/DD/YYYY') : '—';

    // Viewing-as options (prototype). Roles come from RoleType enum; users default to the current user.
    this.viewAsRoles = Object.keys(RoleType)
      .filter(k => isNaN(Number(k)))
      .map(k => ({ id: (RoleType as any)[k], name: this.formatEnumName(k) }));
    if (this.viewAsRoleId == null) this.viewAsRoleId = roleId;

    const currentUserId = this._coreHelper.getUserId();
    if (this.viewAsUsers.length === 0) {
      // TODO: load selectable users from API for prototype review
      this.viewAsUsers = [{ id: currentUserId, name: this.userName }];
    }
    if (this.viewAsUserId == null) this.viewAsUserId = currentUserId;
  }

  onViewAsChange() {
    // Prototype only: no real permission change. TODO: hook into prototype role/user simulation if required.
    this._commonNotificationService.displayInfoMessage('Viewing as is prototype only.');
  }

  private formatEnumName(name: string): string {
    if (!name) return '';
    return name.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ');
  }
  //#endregion

  //💡 #region Notification
  toggleNotificationPanel() {
    this.showNotificationPanel = !this.showNotificationPanel;
    if (this.showNotificationPanel) {
      this.closeProfilePanel();
      this.getNotificationByUser();
    }
  }

  closeNotificationPanel() {
    this.showNotificationPanel = false;
  }

  // Close popover on outside click (dialogs opened from the panel are outside, so it closes then too)
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showNotificationPanel && this.notificationWrapper
      && !this.notificationWrapper.nativeElement.contains(event.target)) {
      this.closeNotificationPanel();
    }
    if (this.showProfilePanel && this.profileWrapper
      && !this.profileWrapper.nativeElement.contains(event.target)) {
      this.closeProfilePanel();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.closeNotificationPanel();
    this.closeProfilePanel();
  }

  requestVob() {
    this.closeNotificationPanel();
    // TODO: confirm target route for "Request a VOB"
    this.router.navigate(['/auth/services/vob']);
  }

  requestPrecert() {
    this.closeNotificationPanel();
    // TODO: wire to Precert request route once available
    this.commingSoon();
  }

  trackByNotificationId(index: number, item: any) {
    return item?.notificationId ?? index;
  }

  async getNotificationByUser() {
    let currentUserId = this._coreHelper.getUserId();
    if (currentUserId == undefined || currentUserId == null)
      return;

    await lastValueFrom(this._headerService.getNotificationByUserId()).then((response) => {
      if (response.apiStatus) {
        this.notifications = response.apiData ?? [];
        this.notifications.forEach(res => {
          res.tillNow = moment.utc(res.notifyDate).fromNow();
        })

        this.notificationsList = this.notifications;

        //Set Total Count and Unread message counts
        if (this.notifications.length > 0) {
          this.notificationUnreadCount = this.notifications[0].unreadCount;
          this.notificationCount = this.notifications[0].totalMessages;
        } else {
          this.notificationUnreadCount = 0;
          this.notificationCount = 0;
        }

        //For Notification Auto Popup
        let displayNotificationList = [];
        displayNotificationList = this.notifications.filter(data => data.isDisplay === 1);
        if (displayNotificationList.length > 0 && displayNotificationList.length <= 5) {
          this._coreHelper.notificationData.isMultipleNotification = false;
          let displayedNotificationIds = [];
          displayNotificationList.forEach(res => {
            this._coreHelper.notificationData.notificationTitle = res.title;
            this._coreHelper.notificationData.notificationMessage = res.message;
            this._coreHelper.notificationData.notificationDate = res.notifyDate;
            this._coreHelper.notificationData.notificationTillNow = res.tillNow;
            this._commonNotificationService.displayNotification();
            displayedNotificationIds.push(res.notificationId);
          });
          if (displayedNotificationIds.length > 0) {
            let requestModel = {
              'notificationIds': displayedNotificationIds.join()
            }
            lastValueFrom(this._headerService.markNotificationDisplayed(requestModel)).then((response) => {
              if (response.apiStatus) {
                displayedNotificationIds = [];
                displayNotificationList = [];
              }
            });
          }
        }
      }
    });
  }

  async markNotificationAsReaded(item: any, markAll: boolean = false) {
    if (item != null) {
      this.navigateURL = item.navigationUrl;
    }

    if (item != null && item.isReaded == 1) {
      this.closeNotificationSlider();
      return;
    }
    let requestModel = {
      notificationId: (item == null) ? 0 : item.notificationId,
      doDelete: MartkUserNotificationMsg.MarkDeleteNone,
      doReaded: (markAll) ? MartkUserNotificationMsg.MarkAllReaded : MartkUserNotificationMsg.MarkReadedById,
      byUserId: 0,
    }
    await lastValueFrom(this._headerService.markNotificationAsReaded(requestModel)).then((response) => {
      if (response.apiStatus) {
        if (markAll) {
          this._commonNotificationService.displaySuccessMessage('ALL Messages are marked as readed.');
        }
        this.closeNotificationSlider();
      }
    });
  }

  async deleteNotificationMessage(item: any, deleteAll: boolean = false) {
    let requestModel = {
      notificationId: (item == null) ? 0 : item.notificationId,
      doDelete: (deleteAll) ? MartkUserNotificationMsg.MarkAllDeleted : MartkUserNotificationMsg.MarkDeleteById,
      doReaded: MartkUserNotificationMsg.MarkReadedNone,
      byUserId: 0,
    }
    await lastValueFrom(this._headerService.markNotificationAsReaded(requestModel)).then((response) => {
      if (response.apiStatus) {
        if (deleteAll) {
          this._commonNotificationService.displaySuccessMessage('ALL Messages are deleted.');
        } else {
          this._commonNotificationService.displaySuccessMessage('Message deleted.');
        }
        this.getNotificationByUser();
      }
    });
  }

  closeNotificationSlider() {
    this.getNotificationByUser();
    this.showSaveConfirmation = true;
  }
  //#endregion


  //🔃 #region User Idle activity confirmation popup.
  onNoOptionSelected() {
    this.showSaveConfirmation = false;
    this.closeNotificationPanel();
  }

  onYesOptionsSelected() {
    this.showSaveConfirmation = false;
    this.closeNotificationPanel();
    if (this.isFacilityUser()) {
      this.router.navigate(['/auth/facility-dashboard']);
    } else {
      this.router.navigateByUrl(this.navigateURL);
    }
  }
  //#endregion
}